import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { type AblyTokenType } from 'hb-react/shared/hooks/useSubscribeToAblyChannel/types';

export const useAblyTokenType = ({
  tokenTypeOverride,
}: {
  tokenTypeOverride?: AblyTokenType;
} = {}): AblyTokenType => {
  const { currentUser, currentAdmin } = useDefaultAppContexts();
  return (
    tokenTypeOverride ||
    (currentAdmin ? 'backoffice' : currentUser ? 'frontoffice' : 'publicoffice')
  );
};
